import joi from 'joi';

import type { SnapshotId } from '../snapshot';
import type { IntentRuleId } from './graphIntent';

export interface CompareGraphOverlayRequest {
  type: 'compare';
  snapshotToCompare: SnapshotId;
}

export interface IntentGraphOverlayRequest {
  type: 'intent';
  intentRuleId: IntentRuleId;
}

export type GraphOverlayRequest =
  | CompareGraphOverlayRequest
  | IntentGraphOverlayRequest;

export function isCompareGraphOverlayRequest(
  overlay?: GraphOverlayRequest | null,
): overlay is CompareGraphOverlayRequest {
  return overlay?.type === 'compare';
}

export function isIntentGraphOverlayRequest(
  overlay?: GraphOverlayRequest | null,
): overlay is IntentGraphOverlayRequest {
  return overlay?.type === 'intent';
}

export const compareGraphOverlayRequestSchema = joi.object().keys({
  type: joi.string().valid('compare').required(),
  snapshotToCompare: joi.string().invalid(joi.ref('snapshot')).required(),
});

export const intentGraphOverlayRequestSchema = joi.object().keys({
  type: joi.string().valid('intent').required(),
  intentRuleId: joi.string().required(),
});

export const graphOverlayRequestSchema = joi.alternatives(
  intentGraphOverlayRequestSchema,
  compareGraphOverlayRequestSchema,
);
